import {getDateSlash} from "../../../../utility/DateUtils";
import React from "react";

const TableHead = () => {
  return <table
      width="100%"
      border={0}
      cellPadding={3}
      cellSpacing={0}
      className="border"
  >
      {" "}
      <tbody>
      <tr>
          {" "}
          <td>
              <strong>Lịch Xổ Số {getDateSlash()}</strong>
          </td>{" "}
          <td colSpan={2} align="center">
              <strong>Thống kê tần suất xổ số</strong>
          </td>{" "}
          <td align="center">
              <strong>Gan cực đại</strong>
          </td>{" "}
          <td align="center">
              <strong>Thống kê Loto</strong>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Miền Nam"
              >
                  <strong>Xổ Số Miền Nam</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số TP. HCM"
              >
                  <span className="icon wait">Xổ Số TP. HCM</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số TP. HCM"
              >
                  Tần suất TP. HCM{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  TP. HCM"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số TP. HCM"
              >
                  GCĐ TP. HCM{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số TP. HCM"
              >
                  Xem Loto TP. HCM{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Đồng Tháp"
              >
                  <span className="icon wait">Xổ Số Đồng Tháp</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đồng Tháp"
              >
                  Tần suất Đồng Tháp{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Đồng Tháp"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Đồng Tháp"
              >
                  GCĐ Đồng Tháp{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Đồng Tháp"
              >
                  Xem Loto Đồng Tháp{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Cà Mau"
              >
                  <span className="icon wait">Xổ Số Cà Mau</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Cà Mau"
              >
                  Tần suất Cà Mau{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Cà Mau"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Cà Mau"
              >
                  GCĐ Cà Mau{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Cà Mau"
              >
                  Xem Loto Cà Mau{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Miền Bắc"
              >
                  <strong>Xổ Số Miền Bắc</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Hà Nội"
              >
                  <span className="icon wait">Xổ Số Hà Nội</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Hà Nội"
              >
                  Tần suất Hà Nội{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Hà Nội"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Hà Nội"
              >
                  GCĐ Hà Nội{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Hà Nội"
              >
                  Xem Loto Hà Nội{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Miền Trung"
              >
                  <strong>Xổ Số Miền Trung</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Bến Tre"
              >
                  <span className="icon wait">Xổ Số Bến Tre</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bến Tre"
              >
                  Tần suất Bến Tre{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Bến Tre"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Bến Tre"
              >
                  GCĐ Bến Tre{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Bến Tre"
              >
                  Xem Loto Bến Tre{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Vũng Tàu"
              >
                  <span className="icon wait">Xổ Số Vũng Tàu</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Vũng Tàu"
              >
                  Tần suất Vũng Tàu{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Vũng Tàu"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Vũng Tàu"
              >
                  GCĐ Vũng Tàu{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Vũng Tàu"
              >
                  Xem Loto Vũng Tàu{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Bạc Liêu"
              >
                  <span className="icon wait">Xổ Số Bạc Liêu</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bạc Liêu"
              >
                  Tần suất Bạc Liêu{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Bạc Liêu"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Bạc Liêu"
              >
                  GCĐ Bạc Liêu{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Bạc Liêu"
              >
                  Xem Loto Bạc Liêu{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Đức hạnh"
              >
                  <strong>Xổ Số Đức hạnh</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Đà Nẵng"
              >
                  <span className="icon wait">Xổ Số Đà Nẵng</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đà Nẵng"
              >
                  Tần suất Đà Nẵng{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Đà Nẵng"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Đà Nẵng"
              >
                  GCĐ Đà Nẵng{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Đà Nẵng"
              >
                  Xem Loto Đà Nẵng{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Long An"
              >
                  <span className="icon wait">Xổ Số Long An</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Long An"
              >
                  Tần suất Long An{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Long An"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Long An"
              >
                  GCĐ Long An{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Long An"
              >
                  Xem Loto Long An{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Cà Mau"
              >
                  <span className="icon wait">Xổ Số Cà Mau</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Cà Mau"
              >
                  Tần suất Cà Mau{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Cà Mau"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Cà Mau"
              >
                  GCĐ Cà Mau{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Cà Mau"
              >
                  Xem Loto Cà Mau{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Cảm ơn"
              >
                  <strong>Xổ Số Cảm ơn</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Bến Tre"
              >
                  <span className="icon wait">Xổ Số Bến Tre</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bến Tre"
              >
                  Tần suất Bến Tre{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Bến Tre"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Bến Tre"
              >
                  GCĐ Bến Tre{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Bến Tre"
              >
                  Xem Loto Bến Tre{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Vũng Tàu"
              >
                  <span className="icon wait">Xổ Số Vũng Tàu</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Vũng Tàu"
              >
                  Tần suất Vũng Tàu{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Vũng Tàu"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Vũng Tàu"
              >
                  GCĐ Vũng Tàu{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Vũng Tàu"
              >
                  Xem Loto Vũng Tàu{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              {" "}
              <a
                  className="hottoday_tinh1"
                  href="/"
                  title="Xổ Số Bạc Liêu"
              >
                  <span className="icon wait">Xổ Số Bạc Liêu</span>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bạc Liêu"
              >
                  Tần suất Bạc Liêu{" "}
              </a>
          </td>
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số  Bạc Liêu"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Bạc Liêu"
              >
                  GCĐ Bạc Liêu{" "}
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Bạc Liêu"
              >
                  Xem Loto Bạc Liêu{" "}
              </a>
          </td>{" "}
      </tr>
      <tr>
          {" "}
          <td>
              <a
                  className="hottoday_mien"
                  href="/"
                  title="Xổ Số Miền Phía Dông"
              >
                  <strong>Xổ Số Miền Phía Dông</strong>
              </a>
          </td>{" "}
          <td className="norightborder">
              <a
                  href="/"
                  title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam"
              >
                  Tần suất Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê tần suất chi tiết xổ số Miền Nam"
                  target="_blank"
              >
                  Chi tiết!..{" "}
              </a>{" "}
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống kê Gan Cực Đại Xổ Số Miền Nam"
              >
                  GCĐ Miền Nam
              </a>
          </td>{" "}
          <td>
              <a
                  href="/"
                  title="Thống Kê lô các cặp số của Xổ Số Miền Nam"
              >
                  Xem Loto Miền Nam
              </a>
          </td>{" "}
      </tr>
      </tbody>
  </table>

}

export default TableHead;